<template>
  <!--page-->
  <div class="p5_bgpage p5_spage">
    <!---s-bt-audio-->
    <div class="p5_buttonaudio">
      <!-- <my-audio></my-audio> -->
    </div>
    <!---s-s-SLOGAN-大-->
    <div class="p5_sliceSLOGANda"><img class="p5_diSLOGANda" src="../../assets/p5/images/imgSLOGAN-da.png"
                                    referrerpolicy="no-referrer"/></div>
    <!--contents-->
    <div class="p5_bgcontents p5_scontents">
      <!---s-tx-content-->
      <div class="p5_textcontent">1.活动时间: 2023年7月21日-8月16日；<br/>
        2.活动期间，首次绑定账号可获得召唤次数*2，可通过完成日常任务获取召唤次数；<span style="font-weight: bold;">任务刷新时间为每日04:00</span>;<br/>
        3.唤醒回忆概率随机，每日赠予插画次数无限制，接受插画赠予上限为3次/天;<br/>
        4.兑换钻石奖励需要集齐16张回忆插画，兑换奖励会消耗对应插画；<br/>
        5.累计送出5张插画可额外抽取奖励，每位勇者最多中奖1次。请获得实物奖励的勇者务必填写收件信息，若活动结束后仍未填写收件信息，视为放弃奖励；<br/>
        6.实物奖励将在活动结束后30个工作日内发放；<br/>
        7.本次活动中获取的奖励，同一账号仅可领取一次。
      </div>
    </div>
    <!--bar-->
    <bar :value="5"></bar>
  </div>
</template>

<style lang="css" scoped>
@import '../../assets/p5/css/s5.css';
</style>

<script>


import Bar from "@/components/bar";
// import MyAudio from "@/components/audio";

export default {
  name: 'Rule',
  components: {Bar},
  data() {
    return {};
  },

  methods: {},
  mounted() {
    document.getElementsByClassName("p5_buttonaudio")[0].appendChild(this.$myAudio.$el);

  },
};
</script>
<style scoped>
.p5_bgpage {
  background-size: 100% auto;
  height: 100vh;
  min-height: 13.34rem;
}

.p5_textcontent {
  line-height: 0.56rem;
}

.p5_scontents {
  height: calc(100vh - 13.34rem + 9.61rem);
  min-height: 9.61rem;
}
</style>